import { Box, Button, Layer, RadioButtonGroup, Spinner, Text } from "grommet";
import React from "react";
import './RoleChoose.css';
import { observer } from "mobx-react";
import { useStore } from "../../Hooks/useStore";
import { Auth } from "aws-amplify";

function RoleChoose(props) {
    const { rootStore } = useStore();

    const onSubmit = async () => {
        let userAttribute2 = await Auth.currentAuthenticatedUser();
        let val;
        let rolename;
        let uRole = rootStore.userStore.getURole;
        if (uRole == "admin1") {
             val = "admin";
             rolename = "SUPERADMIN";
        } else if (uRole == "admin") {
            val = uRole;
            rolename = "ADMIN";
        } else if (uRole == "ems") {
            val = uRole;
            rolename = "EMS";
        }
        await props.storeSession(userAttribute2, rootStore.userStore.getCognitoUser, true, val, rolename);
        rootStore.userStore.handleRoleSelectModal(false);
    }

    const styles = {
        container: {
          overflow: "hidden",
          width: 600,
          paddingBottom: 30,
        },
        header: {
          padding: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px 12px 0px 0px",
          background: "#E9F2FF",
          color: "#4B628A",
          fontFamily: "Inter",
          fontSize: 20,
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "26px",
        },
        content: {
          padding: 30,
          textAlign: "center",
          color: "#4B628A",
          fontFamily: "Inter",
          fontSize: 16,
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "22px",
        },
        newLineText: {
            textAlign: "center",
            color: "#4B628A",
            fontFamily: "Inter",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "22px",
            display: 'block'
        },
        btn: {
            padding: "14px 49px",
            backgroundColor: "#357EFF",
            borderColor: "#357EFF",
            color: "#fff",
            borderRadius: 10,
          },
      };

    return (
        <Layer style={{ borderRadius: "12px" }}>
            <Box style={styles.container}>
                <Text className="title" style={{ background: "#E9F2FF", padding: "12px -1px 17px 17px", textAlign: "center", borderTopLeftRadius: "12px", borderTopRightRadius: "12px", color: "#4B628A", fontFamily: "inherit", fontSize: "18px", fontStyle: "normal", fontWeight: "600", lineHeight: "26px", padding: "20px", width: "100%" }}>Choose a role you want to login with</Text>
                <Box style={styles.content}>
                    <RadioButtonGroup
                        name="doc"
                        options={rootStore.userStore.getRoleArr.map((item) => ({
                            label: item.rolename,
                            value: item.rolename == "SuperAdmin" ? `${item.value}1` : `${item.value}`
                        }))}
                        value={rootStore.userStore.getURole}
                        onChange={(event) => {rootStore.userStore.handleRoleChoose(event.target.value);}}
                        className="genderContainer"
                    />
                </Box>
                <Box direction="row" align="center" justify="center">
                    <Button
                        style={styles.btn}
                        label="Submit"
                        onClick={onSubmit}
                        className="btn"
                        disabled={rootStore.userStore.getURole == "" ? true : false}
                    />
                </Box>
            </Box>
        </Layer>
    );
}
export default observer(RoleChoose);
